export const defaultColumns = [
  { label: 'Status', value: 'status', className: 'w-20' },
  { label: 'Perfil', value: 'user_role', className: 'w-20' },
  { label: 'Nome', value: 'full_name_with_profile_picture' },
  { label: 'Último acesso', value: 'lastSeenAt', className: 'w-32' },
  { label: 'Ações', value: 'actions', className: 'w-9' },
]
